import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fab', 'panel']

  connect() {
    this.collapsed = true
    this.applyState()
  }

  toggle(event) {
    if (event) event.preventDefault()
    this.collapsed = !this.collapsed
    this.applyState()
  }

  expandPopup() {
    if (!this.collapsed) return
    this.collapsed = false
    this.applyState()
  }

  collapsePopup() {
    if (this.collapsed) return
    this.collapsed = true
    this.applyState()
  }

  applyState() {
    if (this.collapsed) {
      this.panelTarget.classList.add('hidden')
      this.fabTarget.classList.remove('hidden')
    } else {
      this.fabTarget.classList.add('hidden')
      this.panelTarget.classList.remove('hidden')
    }
  }
}
